import React from 'react';
import Drawer from '@kufox/mui/Drawer';
import { styled } from '@kufox/mui/emotion';
import useTheme from '@kufox/mui/hooks/useTheme';
import useMediaQuery from '@kufox/mui/hooks/useMediaQuery';
import { CloseOutlined } from '@kufox/icons';
import I18nBox from '../I18nBox';

const CloseDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 32px;
`;

const CusDrawer = styled(Drawer)`
  padding: 24px 0 !important;
  width: ${(props) => (props.isMobile ? '100vw' : '320px')};
  height: 100vh;
  overflow: scroll;
  background-color: ${(props) => props.colors.base} !important;
`;

export default function I18nDrawer({ show, type = 'lang', onClose, ...rest }) {
  const isMobile = useMediaQuery('(max-width:400px)');
  const theme = useTheme();
  return (
    <CusDrawer
      show={show}
      anchor="right"
      isMobile={isMobile}
      onClose={onClose}
      colors={theme.colors}
    >
      <CloseDiv>
        <CloseOutlined
          size="24"
          onClick={onClose}
          style={{ cursor: 'pointer' }}
          color={theme.colors.text}
        />
      </CloseDiv>
      <I18nBox inDrawer type={type} {...rest} closeI18nDrawer={onClose} />
    </CusDrawer>
  );
}
